module.exports = __webpack_public_path__ + "static/media/group-avatar-default.7639518a.svg";